import { zonedTimeToUtc } from 'date-fns-tz';

const LOCALE = 'en-US';
const TZ_ORIGIN = 'America/New_York';
const TZ_STANDARD = 'UTC';

/**
 * Checks if a value is "empty" (null, undefined, an empty string, or starts with '0001').
 * @param {any} value
 * @returns {boolean}
 */
const isValueEmpty = (value) => {
  if (value === null || typeof value === 'undefined' || value === '') {
    return true;
  }
  return typeof value === 'string' && value.startsWith('0001');
};

/**
 * Take a datetime ISO string returned from API and convert it to 'Month day, Year' format.
 * @param {string | null | undefined} dt Datetime in EST (business-defined), e.g., '2019-10-31T00:00:00'
 * @returns {string}
 */
export const formatMonthDayYear = (dt) => {
  // backend returns sticker date as null or 0001-mm-dd... if not found
  if (isValueEmpty(dt) || dt.startsWith('0001')) {
    return '';
  }

  // First, convert EST to standard UTC
  const utcDt = zonedTimeToUtc(dt, TZ_ORIGIN);
  return utcDt.toLocaleDateString(LOCALE, {
    timeZone: TZ_STANDARD,
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
};

export default {
  formatMonthDayYear,
};